import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24 px-4 sm:px-6 lg:px-8`;
const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;

const Heading = tw.h1`font-bold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-gray-900 leading-tight`;
const HeadingRow = tw.div`flex flex-col items-center text-center`;
const Text = tw.div`mt-8 text-base text-gray-600 max-w-3xl mx-auto`;

const BlogGrid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12`;
const BlogCard = tw.div`bg-white rounded-lg shadow-lg overflow-hidden`;
const BlogImage = tw.img`w-full h-48 object-cover`;
const BlogContent = tw.div`p-6`;
const BlogTitle = tw.h3`text-xl font-semibold text-gray-900 mb-2`;
const BlogExcerpt = tw.p`text-gray-600 mb-4`;
const BlogMeta = tw.div`flex items-center text-sm text-gray-500`;
const BlogDate = tw.span`mr-4`;
const BlogAuthor = tw.span`text-gray-500`;

export default () => {
  const blogPosts = [
    {
      id: 1,
      title: "Pourquoi digitaliser la gestion des visiteurs ?",
      excerpt: "Découvrez les avantages de la digitalisation pour la sécurité, la traçabilité et l'expérience visiteur dans les entreprises.",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&q=80",
      date: "2024-06-01",
      author: "Équipe Tanga"
    },
    {
      id: 2,
      title: "Sécurité & conformité : les enjeux du contrôle d'accès",
      excerpt: "Comment Tanga aide les entreprises à respecter les normes de sécurité et la confidentialité des données visiteurs.",
      image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
      date: "2024-05-20",
      author: "Équipe Tanga"
    },
    {
      id: 3,
      title: "Expérience visiteur : check-in rapide et sans stress",
      excerpt: "Grâce à la pré-inscription et au QR code, l'accueil devient plus fluide et agréable pour tous.",
      image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=800&q=80",
      date: "2024-05-10",
      author: "Équipe Tanga"
    },
    {
      id: 4,
      title: "Rapports & traçabilité : piloter la sécurité en temps réel",
      excerpt: "Tanga permet de générer des rapports détaillés pour suivre les flux visiteurs et anticiper les risques.",
      image: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=800&q=80",
      date: "2024-04-28",
      author: "Équipe Tanga"
    }
  ];

  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>Blog</Heading>
          </HeadingRow>
          <Text>
            <p className="text-center mb-8">
              Découvrez nos derniers articles sur l'innovation, l'entrepreneuriat et le développement en Afrique.
            </p>
          </Text>

          <BlogGrid>
            {blogPosts.map((post) => (
              <BlogCard key={post.id}>
                <BlogImage src={post.image} alt={post.title} />
                <BlogContent>
                  <BlogTitle>{post.title}</BlogTitle>
                  <BlogExcerpt>{post.excerpt}</BlogExcerpt>
                  <BlogMeta>
                    <BlogDate>{post.date}</BlogDate>
                    <BlogAuthor>Par {post.author}</BlogAuthor>
                  </BlogMeta>
                </BlogContent>
              </BlogCard>
            ))}
          </BlogGrid>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}; 